<template>
  <b-container v-if="this.$root.signedIn">
    <h3>{{ summary.surveyName }}</h3>
    <br>
    <b-tabs>
      <b-tab title="Summary" active>
        <b-container class="pt-5">
          <b-row>
            <b-col cols=6>
              <b-container class="pl-0 pr-0 pb-0 pt-0">
                <b-row class="text-left mb-4 border-bottom">
                  <b-col class="font-weight-bold">
                    Programme
                  </b-col>
                  <b-col>
                    {{ summary.programmeName }}
                  </b-col>
                </b-row>
                <b-row class="text-left mb-4 border-bottom">
                  <b-col class="font-weight-bold">
                    Customer
                  </b-col>
                  <b-col>
                    {{ summary.customerName }}
                  </b-col>
                </b-row>
                <b-row class="text-left mb-4 border-bottom">
                  <b-col class="font-weight-bold">
                    Primary/Secondary Industry
                  </b-col>
                  <b-col>
                    {{ summary.customerIndustry }} {{ summary.customerSecondaryIndustry ? '/' : '' }} {{ summary.customerSecondaryIndustry }}
                  </b-col>
                </b-row>
                <b-row class="text-left mb-4 border-bottom">
                  <b-col class="font-weight-bold">
                    Country/Region
                  </b-col>
                  <b-col>
                    {{ summary.customerCountry }} {{ summary.customerRegion ? '-' : '' }} {{ summary.customerRegion }}
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
            <b-col cols=6>
              <Gauge v-if="this.summary.overallScore" 
                     :width="400" 
                     :height="240" 
                     :chart-data="parseFloat(this.summary.overallScore).toFixed(2)"
                     :programme="this.summary.programmeName"/>
            </b-col>
          </b-row>
          <b-row class="text-left mb-4 border-bottom">
            <b-col class="font-weight-bold">
              Period/Year
            </b-col>
            <b-col>
              {{ summary.period }}&nbsp;{{ summary.year }}
            </b-col>
            <b-col cols=3 class="font-weight-bold">
              Overall Score
            </b-col>
            <b-col cols=3>
              {{ parseFloat(this.summary.overallScore).toFixed(2) }}
            </b-col>
          </b-row>
          <b-row class="text-left mb-4 border-bottom">
            <b-col cols=3 class="font-weight-bold">
              Total Responses
            </b-col>
            <b-col cols=3>
              {{ summary.totalResponses }}
            </b-col>
            <b-col cols=3 class="font-weight-bold">
              Average Comments
            </b-col>
            <b-col cols=3>
              {{ parseFloat(this.summary.averageComments).toFixed(2) }}
            </b-col>
          </b-row>
          <b-row class="text-left mb-4 border-bottom">
            <b-col cols=3 class="font-weight-bold">
              Number of Staff/Units
            </b-col>
            <b-col cols=3>
              {{ summary.number_of_staff > 0 ? `${summary.number_of_staff} staff` : '' }}
              {{ summary.number_of_staff > 0 && summary.number_of_units > 0 ? ', ' : '' }}
              {{ summary.number_of_units > 0 ? `${summary.number_of_units} units` : '' }}
            </b-col>
            <b-col cols=3 class="font-weight-bold">
              Sponsor
            </b-col>
            <b-col cols=3>
              {{ summary.sponsor }} {{ summary.sponsor_contact_number ? `(${summary.sponsor_contact_number})` : '' }}
            </b-col>
          </b-row>
          <b-row class="text-left mb-4 border-bottom">
            <b-col cols=3 class="font-weight-bold">
              Areas
            </b-col>
            <b-col cols=3>
              {{ summary.area }}
            </b-col>
            <b-col cols=3 class="font-weight-bold">
              Gatekeeper
            </b-col>
            <b-col cols=3>
              {{ summary.gatekeeper }} {{ summary.gatekeeper_contact_number ? `(${summary.gatekeeper_contact_number})` : '' }}
            </b-col>
          </b-row>
          <b-row class="text-left mb-4 border-bottom">
            <b-col cols=3 class="font-weight-bold">
              External POC
            </b-col>
            <b-col v-if="external_poc" class="font-weight-bold">
              <font-awesome-icon icon="check" />
            </b-col>
          </b-row>

          <b-row class="text-left mb-4 border-bottom">
            <b-col cols=3 class="font-weight-bold">
              Accreditations
            </b-col>
            <b-col cols=3>
              <span v-html="summary.accreditations"/>
            </b-col>
            <b-col cols=3 class="font-weight-bold">
              Customisation
            </b-col>
            <b-col cols=3>
              <span v-html="summary.customization"/>
            </b-col>
          </b-row>
        </b-container>
      </b-tab>
      <b-tab title="Recommendations">
        <recommendations-list :survey-run-id="summary.surveyRunId" v-if="summary.surveyRunId"/>
      </b-tab>
      <b-tab title="Quick Wins">
        <quick-wins-list :survey-run-id="summary.surveyRunId" v-if="summary.surveyRunId"/>
      </b-tab>
      <b-tab title="Comments">
        <comments-list :survey-runs="[summary]" v-if="!loading"/>
      </b-tab>
    </b-tabs>
    <survey-analysis :survey-runs="[summary]" v-if="!loading" />
  </b-container>
</template>
<script>

import * as API from "@/services/API";
import Gauge from "@/components/Gauge.vue";
import SurveyAnalysis from "@/components/SurveyAnalysis.vue";
import RecommendationsList from "@/components/RecommendationsList.vue";
import QuickWinsList from "@/components/QuickWinsList.vue";
import CommentsList from "@/components/CommentsList.vue";

export default {
  name: "SurveySummary",
  components: { Gauge, SurveyAnalysis, RecommendationsList, QuickWinsList, CommentsList },
  props: ["surveyRunId"],
  data: function() {
    return {
      summary: {},
      external_poc: false,
      loading: true
    };
  },
  mounted: function() {
    return API.getSurveyRunSummary(this.surveyRunId).then(
      summary => {
        this.summary = summary;
        this.external_poc = summary.external_poc;
        this.loading = false;
      }
    );
  },
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/SurveySummary.vue